import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";

let _config = window['_config'] || {};


let app = {
    debug: false,
};
window.app = app || {};

import * as parallax from './scripts/parallax';
parallax.init();

import * as fadeIn from './scripts/fade-in';
fadeIn.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({
    submitOnReset: true
});

import * as ajaxFormExtend from './scripts/ajax-form-extend';
ajaxFormExtend.init();

import * as datepicker from '@elements/datepicker';
datepicker.init();

import * as rangeDatepicker from '@elements/datepicker-range';
rangeDatepicker.init();
